import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import { ToggleModalTitle } from "../../../../constants";
import { ToggleModalSubTitle } from "../../../../data/uiKits/Modal";
import ToggleModalBody from "./ToggleModalBody";

const ToggleModal = () => {
  return (
    <Col xl="4">
      <Card>
        <CommonCardHeader title={ToggleModalTitle} span={ToggleModalSubTitle} />
        <CardBody>
          <ToggleModalBody />
        </CardBody>
      </Card>
    </Col>
  );
};
export default ToggleModal;
